import { useCallback, useEffect, useMemo } from "react";

import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import { BILLING_CYCLES } from "utils/constants";

export default function useCheckout() {
  const [searchParams, setSearchParams] = useSearchParams();

  const form = useForm({
    defaultValues: {
      billingPeriod: BILLING_CYCLES.YEARLY.toString(),
      packageId: null,
      paymentTypeId: null,
    },
  });

  const changeTab = useCallback(
    (tab: string) => {
      searchParams.set("tab", tab);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  const billingPeriod = form.watch("billingPeriod");
  const packageId = form.watch("packageId");
  const paymentTypeId = form.watch("paymentTypeId");

  const disabledTabs = useMemo(
    () => ({
      method: !(Boolean(billingPeriod) && Boolean(packageId)),
      payment: !(Boolean(billingPeriod) && Boolean(packageId) && Boolean(paymentTypeId)),
    }),
    [billingPeriod, packageId, paymentTypeId],
  );

  const activeTab = searchParams.get("tab") ?? "package";

  useEffect(() => {
    if (disabledTabs.method && activeTab === "method") {
      changeTab("package");
    } else if (disabledTabs.payment && activeTab === "payment") {
      changeTab("package");
    }
  }, [disabledTabs, activeTab, changeTab]);

  return {
    form,
    activeTab,
    changeTab,
    disabledTabs,
  };
}
